export default __webpack_public_path__ + "media/images/home/nl/preview-3-d382d1050651133c9d99b2156fb5cc62.jpg";